import React from 'react'
import Link from 'gatsby-link'
import Helmet from 'react-helmet';
import {Window} from 'goose-css';
import {WindowContent} from 'goose-css';
import '../style/screen.scss';

class Template extends React.Component {
  render() {
    const {children} = this.props

    return <Window>
        <WindowContent>
            <Helmet defaultTitle="Bible Word Stats" titleTemplate="%s - Bible Word Stats"/>
            {children()}
        </WindowContent>
    </Window>;
  }
}

export default Template



// WEBPACK FOOTER //
// ./src/layouts/index.js